/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Grant } from './Grant';
import {
    GrantFromJSON,
    GrantFromJSONTyped,
    GrantToJSON,
} from './Grant';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
} from './User';

/**
 * 
 * @export
 * @interface ManagedUser
 */
export interface ManagedUser {
    /**
     * 
     * @type {User}
     * @memberof ManagedUser
     */
    user: User;
    /**
     * 
     * @type {Grant}
     * @memberof ManagedUser
     */
    grant: Grant;
}

/**
 * Check if a given object implements the ManagedUser interface.
 */
export function instanceOfManagedUser(value: object): value is ManagedUser {
    let isInstance = true;
    isInstance = isInstance && "user" in value && value["user"] !== undefined;
    isInstance = isInstance && "grant" in value && value["grant"] !== undefined;

    return isInstance;
}

export function ManagedUserFromJSON(json: any): ManagedUser {
    return ManagedUserFromJSONTyped(json, false);
}

export function ManagedUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): ManagedUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user': UserFromJSON(json['user']),
        'grant': GrantFromJSON(json['grant']),
    };
}

export function ManagedUserToJSON(value?: ManagedUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user': UserToJSON(value.user),
        'grant': GrantToJSON(value.grant),
    };
}

